import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IProducts } from '../models/products.model';

export const pendingProductsForSomeoneElseFeatureKey = 'pendingProductsForSomeoneElse';

export interface PendingProductsForSomeoneElseState {
  loadPendingProductsForSomeoneElseResponse: IProducts[];
  loadPendingProductsForSomeoneElseFailure: Error | any;
}

export const initialState: PendingProductsForSomeoneElseState = {
  loadPendingProductsForSomeoneElseResponse: undefined,
  loadPendingProductsForSomeoneElseFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadPendingProductsForSomeoneElse, (state, action) => ({
    ...state
  })),
  on(actions.loadPendingProductsForSomeoneElseSuccess, (state, action) => ({
    ...state,
    loadPendingProductsForSomeoneElseResponse: action.response
  })),
  on(actions.loadPendingProductsForSomeoneElseFailure, (state, action) => ({
    ...state,
    loadPendingProductsForSomeoneElseFailure: action.error
  }))
);

export const getPendingProductsForSomeoneElseResponse = (state: PendingProductsForSomeoneElseState) =>
  state.loadPendingProductsForSomeoneElseResponse;
